import {AbstractEvent} from "@/modules/base/events";
import {Achievement} from "@/modules/archiements/entity";

export default class AfterAchievementAchievedEvent extends AbstractEvent {
  constructor(
    public achievement: Achievement,
  ) {
    super();
  }
}